import { Grid, Typography } from '@mui/material';

import { EditorHtmlField, useSettings } from 'app/main/components';
import { type EditorHtmlFieldProps } from 'app/main/components/fields/EditorHtmlField';
import UploadFile, { UploadFileProps } from 'app/main/components/fields/UploadFile';

import CommunicationsFastAddDialogSettings from 'app/main/modules/communications/CommunicationsFastAddDialogSettings';
import CoursesFastAddDialogSettings from 'app/main/modules/courses/CoursesFastAddDialogSettings';
import DocumentsFolderFastAddDialogSettings from 'app/main/pages/documents-structure/DocumentsFolderFastAddDialogSettings';
import GroupsFastAddDialogSettings from 'app/main/modules/groups/GroupsFastAddDialogSettings';
import LeaveFastAddDialogSettings from 'app/main/modules/leave/LeaveFastAddDialogSettings';
import MailsFastAddDialogSettings from 'app/main/submodules/mails/MailsFastAddDialogSettings';
import PhonesFastAddDialogSettings from 'app/main/submodules/phones/PhonesFastAddDialogSettings';
import RequestsFastAddDialogSettings from 'app/main/modules/requests/RequestsFastAddDialogSettings';
import SkillsFastAddDialogSettings from 'app/main/modules/skills/SkillsFastAddDialogSettings';
import SocialNetworksFastAddDialogSettings from 'app/main/submodules/socialnetworks/SocialNetworksFastAddDialogSettings';
import UsersFastAddDialogSettings from 'app/main/modules/users/UsersFastAddDialogSettings';

export function InlineTitle({ text }: { text: string }) {
	const { t } = useSettings();

	return (
		<Grid size={12}>
			<Typography className="p-4" variant="subtitle2">
				{t(text)}
			</Typography>
		</Grid>
	);
}

export function DescriptionSection(props: Pick<EditorHtmlFieldProps, 'name' | 'value' | 'isEdit' | 'sendChange'>) {
	return (
		<Grid size={12}>
			<EditorHtmlField {...props} />
		</Grid>
	);
}

export function ImageSection(props: Pick<UploadFileProps, 'fieldName' | 'fileName' | 'path' | 'value' | 'sendChange'>) {
	return (
		<Grid size={12}>
			<UploadFile {...props} />
		</Grid>
	);
}

const fastAddDialogs = {
	communications: CommunicationsFastAddDialogSettings,
	courses: CoursesFastAddDialogSettings,
	groups: GroupsFastAddDialogSettings,
	leave: LeaveFastAddDialogSettings,
	requests: RequestsFastAddDialogSettings,
	mails: MailsFastAddDialogSettings,
	phones: PhonesFastAddDialogSettings,
	skills: SkillsFastAddDialogSettings,
	socialnetworks: SocialNetworksFastAddDialogSettings,
	sys_documents_folders: DocumentsFolderFastAddDialogSettings,
	users: UsersFastAddDialogSettings
};

export default fastAddDialogs;
